import { ajax } from '../ajax.mjs';
import { g as getNewScrollPosition } from './55674673.mjs';

function ajaxLegacy(url, contentCallback, finishCallback) {
  return ajax.get(url).then((xhr) => {
    if (typeof contentCallback === "function") {
      if (xhr.status === 200) {
        contentCallback(xhr.responseText, xhr.status);
      } else {
        contentCallback(
          '<div class="p_message p_message--error p_layer--error"><b>Entschuldigung!</b> Aufgrund von technischen Problemen kann der Inhalt leider nicht geladen werden. Bitte versuchen Sie es zu einem sp\xE4teren Zeitpunkt erneut.</div>',
          xhr.status
        );
      }
    }
    if (typeof finishCallback === "function") {
      finishCallback(xhr.status);
    }
  });
}

var index = /*         */Object.freeze({
  __proto__: null,
  ajaxLegacy: ajaxLegacy,
  getNewScrollPosition: getNewScrollPosition
});

export { ajaxLegacy as a, index as i };
/*                                 */
